import { Button, Card, Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style/style.css";

function Login() {
  const navigate = useNavigate();

  const [obj, setObj] = useState({ username: "", password: "" });
  const [status, setStatus] = useState("");

  const loginSubmit = async () => {
    if (
      obj.username === "leadzen" &&
      obj.password === "5c4d9bcf2bb9330f6a65e57cdd8e827c"
    ) {
      localStorage.setItem("auth", "yes");
      navigate("/dashboard");
    } else {
      setStatus("Wrong username or password!");
    }
  };

  return (
    <div className="login">
      <Col style={{ height: "100%", width: "100%" }}>
        <div
          style={{
            height: "70px",
            width: "100%",
            backgroundColor: "rgba(11,14,24,255)",
          }}
        />
        <div
          style={{
            height: "91%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <form>
            <Card className="shadow login_card">
              <Card.Title>Login to your account</Card.Title>
              <Card.Subtitle>Enter username and password</Card.Subtitle>
              <div style={{ marginTop: "30px" }}>
                <TextField
                  style={{ marginTop: "15px", width: "100%" }}
                  autoFocus
                  value={obj.username}
                  onChange={(e) => setObj({ ...obj, username: e.target.value })}
                  id="outlined-basic"
                  label="Username"
                  variant="filled"
                />
                <br></br>
                <TextField
                  style={{ marginTop: "10px", width: "100%" }}
                  value={obj.password}
                  onChange={(e) => setObj({ ...obj, password: e.target.value })}
                  id="outlined-basic"
                  type="password"
                  label="Password"
                  variant="filled"
                />
                <br></br>
                <Button
                  style={{ marginTop: "20px", width: "100%" }}
                  type="submit"
                  onClick={() => loginSubmit()}
                  variant="primary"
                >
                  Login
                </Button>
                <div style={{ marginTop: "10px" }}>{status}</div>
              </div>
            </Card>
          </form>
        </div>
      </Col>
    </div>
  );
}

export default Login;
